import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { PipesModule } from './../shared/pipes/pipes.module';
import { NavService } from './shared/nav.service';
import { McHttpService } from './../shared/services/mc-http.service';

import { NavComponent } from './nav.component';
import { NavButtonComponent } from './nav-button/nav-button.component';
import { NavGroupComponent } from './nav-group/nav-group.component';
import { NavItemComponent } from './nav-item/nav-item.component';
import { WelcomeMessageComponent } from './welcome-message/welcome-message.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    PipesModule
  ],
  declarations: [
    NavComponent,
    NavButtonComponent,
    NavGroupComponent,
    NavItemComponent,
    WelcomeMessageComponent
  ],
  exports: [ NavComponent ],
  providers: [ NavService, McHttpService ]
})
export class NavModule { }
